import { render, staticRenderFns } from "./evaluationCard.vue?vue&type=template&id=45613a6c&scoped=true&"
import script from "./evaluationCard.vue?vue&type=script&lang=js&"
export * from "./evaluationCard.vue?vue&type=script&lang=js&"
import style0 from "./evaluationCard.vue?vue&type=style&index=0&id=45613a6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45613a6c",
  null
  
)

export default component.exports